/** @format */
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/core';
import { IdentityProviderLogin, LocalizedString } from 'common-typescript/types';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService, ConfigService } from 'sis-common';
import { OrganisationNameService } from '../organisation/organisation-name.service';
import { UniversityService } from '../service/university.service';

export interface IdpItem {
    name: LocalizedString;
    action: () => void;
}

@Component({
    selector: 'sis-student-login-page',
    templateUrl: './student-login-page.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StudentLoginPageComponent implements OnInit {
    @Input() loginTarget: string;
    @Input() continueWithoutLogin: string;

    logins: IdpItem[];
    universityName$: Observable<string>;
    suomiFiLoginEnabled$: Observable<boolean>;
    showLoginOptions$: Observable<boolean>;

    private suomiFiLoginUrl: string;

    constructor(
        private configService: ConfigService,
        private authService: AuthService,
        private universityService: UniversityService,
        private organisationNameService: OrganisationNameService,
        private stateService: StateService,
    ) {}

    ngOnInit(): void {
        const config = this.configService.get();
        this.logins = config?.identityProviderLogins.map((idpLogin: IdentityProviderLogin) => ({
            name: idpLogin.name,
            action: () => this.authService.moveToAuthUrl(idpLogin.shibbolethUrl, this.loginTarget),
        }));
        this.universityName$ = this.organisationNameService.getOrgName(this.universityService.getCurrentUniversityOrgId());
        this.suomiFiLoginUrl = config?.suomiFiLoginUrl;
        this.suomiFiLoginEnabled$ = this.suomiFiLoginUrl
            ? this.universityService
                  .getCurrentUniversitySettings()
                  .pipe(map(settings => !!settings?.frontendFeatureToggles?.suomiFiLoginEnabled))
            : of(false);
        this.showLoginOptions$ = this.authService.initialized$;
    }

    selectIdp(item: IdpItem): void {
        item.action();
    }

    navigateWithoutLogin(): void {
        this.stateService.go(this.continueWithoutLogin);
    }

    loginWithSuomiFi(): void {
        this.authService.moveToAuthUrl(this.suomiFiLoginUrl, this.loginTarget);
    }
}
